import { useEffect, useState } from 'react';
import { useLanguage } from './LanguageContext';
import defaultTranslation from './translations/de.json'
import { ConfigData } from '../configTypes';

const useTranslation = () => {
  const { language } = useLanguage();
  const [translations, setTranslations] = useState<ConfigData>(defaultTranslation as ConfigData);

  useEffect(() => {
    import(`./translations/${language}.json`)
      .then((module: { default: ConfigData }) => {
        setTranslations(module.default);
      })
      .catch((error) => {
        console.error(`Could not load ${language}.json`, error);
      });
  }, [language]);

  return translations;
};

export default useTranslation;
